import { Box, Spacer } from '@jfs/ui-new'
import { useNavigation } from '@react-navigation/core'
import { useEffect, useRef, useState } from 'react'
import { AadharNumberEditText } from '../../comps/AadharNumberEditText'
import { AepsButton } from '../../comps/AepsButton'
import { AepsCheckBox } from '../../comps/AepsCheckBox'
import { Container } from '../../comps/Container'
import { Title } from '../../comps/Title'
import { useStores } from '../../data/store'
import { Screens } from '../../nav/Screens'
import { isOTPRequiredChannel } from '../../util/utill'

export const EnterAadhaarCardScreen = () => {
  const { updateAadhaarCardNumber, getConsent, channelId } = useStores((root) => ({
    updateAadhaarCardNumber: root.agent.updateAadhaarCardNumber,
    getConsent: root.consents.getConsent,
    channelId: root.agent.session.CHANNEL_ID,
  }))


  const [aadhaarCardNumber, setAadhaarCardNumber] = useState('')
  const [isChecked, setIsChecked] = useState(false)
  const [isAadharValid, setAadharValid] = useState(false)


  const navigation = useNavigation()

  useEffect(() => {
    navigation.setOptions({ headerTitle: 'AADHAAR Verification' })
  }, [navigation])

  const onAddharCardSubmit = () => {
    updateAadhaarCardNumber(aadhaarCardNumber)
    navigation.navigate(
      (isOTPRequiredChannel(channelId) ? Screens.ENTER_AADHAAR_OTP : Screens.SCAN_FINGERPRINT) as never,
      { isFromEnterAadhaarCardScreen: true } as never,
    )
  }

  const onAadhaarCardNumberChanged = (aadhaarNum: string, isValidAadhaar: boolean) => {
    setAadhaarCardNumber(aadhaarNum)
    setAadharValid(isValidAadhaar)
  }

  const onCheckBoxClick = (checked: boolean) => setIsChecked(checked)

  return (
    <Container showFooter={true}>
      <Box overflow={'scroll'} f={1}>
        <Title title={'Please enter your 12-digit\nAADHAAR Number'} />
        <Spacer size={32} />

        <Box marginHorizontal={24}>
          <AadharNumberEditText onTextChanged={onAadhaarCardNumberChanged} label="AADHAAR Number" type="NORMAL" />
        </Box>
        <Spacer size={16} />
        <AepsCheckBox text={getConsent('AGENT_FINGER_PRINT')} checked={isChecked} onChange={onCheckBoxClick} />
      </Box>
      <AepsButton
        title={isOTPRequiredChannel(channelId) ? 'Generate AADHAAR OTP' : 'Proceed'}
        onPress={onAddharCardSubmit}
        disabled={!isChecked || !isAadharValid}
      />
    </Container>
  )
}
